import { Flex, Table, Tbody, Text } from '@chakra-ui/react'
import { EmptyTablePlaceholder } from 'BrokerTsLib/src/components'
import type { AcquisitionNumber } from 'BrokerTsLib/src/dtos'
import { AcquisitionNumberType } from 'BrokerTsLib/src/enums'

import { useAcquisitionNumber } from '@/hooks/useAcquisitionNumbers'

import { TableSectionRow } from './Section/TableSectionRow'

export const AcquisitionNumbersTable = ({
  rows,
  isDividedDisabled,
}: {
  rows: AcquisitionNumber[]
  isDividedDisabled?: boolean
}) => {
  return (
    <Table
      variant={'simple'}
      fontSize={'md'}
      borderRadius={8}
      layout={['50%', '50%']}
    >
      <Tbody>
        <EmptyTablePlaceholder text={'Žádná ziskatelská čísla'} colSpan={1}>
          {rows
            .filter((x) => x.acquisitionNumber)
            .map((row, index) => (
              <AcquisitionNumbersTableItem
                key={index}
                row={row}
                isDividedDisabled={isDividedDisabled}
              />
            ))}
        </EmptyTablePlaceholder>
      </Tbody>
    </Table>
  )
}

const AcquisitionNumbersTableItem = ({
  row,
  isDividedDisabled,
}: {
  row: AcquisitionNumber
  isDividedDisabled?: boolean
}) => {
  const { segments, values } = useAcquisitionNumber(row.insurerId, row.acquisitionNumber, isDividedDisabled)

  return (
    values &&
    segments.map((segment, index) => (
      <TableSectionRow
        key={index}
        title={
          index === 0 ? (
            <Flex gap={4} justifyContent={'space-between'}>
              <Text>
                {row.insurerName}
                {row.type ===
                  AcquisitionNumberType.ShortInsuranceOrganizationUnitId &&
                  '(Denní POV)'}
              </Text>
              <Text fontSize={'sm'}>{segment.label}</Text>
            </Flex>
          ) : (
            <Text fontSize={'sm'} textAlign={'right'}>
              {segment.label}
            </Text>
          )
        }
      >
        {values[segment.index]}
      </TableSectionRow>
    ))
  )
}
